import React, { Component } from 'react';
import { connect } from 'react-redux';
import Page from '../../layout/Page';
import Table from '../../components/datatable/Table';
import FilterSection from '../../components/filter/FilterSection';
import Localize from '../../constants/i18n-utils';

import {
    GameHighlightsError,
    getGameHighlightColors,
    getGameHighlightList,
    getGameOptions,
    initCurrentGameHighlight,
    initGameHighlightsList,
    setAction,
    setLoading,
    updateCurrentGameHighlight,
    deleteGameHighlight,
} from '../../redux/actions/gameHighlights/gameHighlights';
import CreateGameHighlights from '../../components/createGameHighlights/CreateGameHighlights';
import {
    formatToDisplayDate,
    formatToServerDate,
    selectItemsToFilter,
    userHasPermission,
} from '../../constants/utils';
import SfaForm from '../../components/SfaForm';
import SfaReadView from '../../components/SfaReadView';
import PillList from '../../components/pillList/PillList';
import { filter, includes } from 'lodash';
import { getRetailerTypeOptions, success } from '../../redux/actions';
import permissions from '../../constants/permissions';
import { ColourComponent } from '../../components/createGameHighlights/ColourComponent';
import OkCancelModal from '../../components/OkCancelModal';

const TOTAL_PER_PAGE = 10;
const GAME_HIGHLIGHT_LIST = 'GAME_HIGHLIGHT_LIST';
const GAME_HIGHLIGHT_READ_VIEW = 'GAME_HIGHLIGHT_READ_VIEW';
const GAME_HIGHLIGHT_CREATE_VIEW = 'GAME_HIGHLIGHT_CREATE_VIEW';
const GAME_HIGHLIGHT_EDIT_VIEW = 'GAME_HIGHLIGHT_EDIT_VIEW';
const ROLE_RE_GAME_HIGHLIGHT_VIEW = 'ROLE_RE_GAME_HIGHLIGHT_VIEW';

class GameHighlightsPage extends Component {
    state = {
        GameHighlights: {
            addEditGameHighlights: Localize.text(
                'game.highlight.addEditGameHighlights',
                'Add / Edit Game Hightlights',
            ),
            gameHighlight: Localize.text(
                'game.highlight.gameHighlight',
                'Game Highlight',
            ),
            highlightId: Localize.text(
                'game.highlight.highlightId',
                'Highlight Id',
            ),
            highlightName: Localize.text(
                'game.highlight.highlightName',
                'Highlight Name',
            ),
            colour: Localize.text('game.highlight.colour', 'Colour'),
            games: Localize.text('game.highlight.games', 'Games'),
            time: Localize.text('game.highlight.time', 'Time'),
            highlightStatus: Localize.text(
                'game.highlight.highlightStatus',
                'Highlight Status',
            ),
            highlightColour: Localize.text(
                'game.highlight.highlightColour',
                'Highlight Colour',
            ),
            name: Localize.text('game.highlight.name', 'Name'),
            newGame: Localize.text('game.highlight.newGame', 'New Game'),
            startDate: Localize.text('game.highlight.startDate', 'Start Date'),
            endDate: Localize.text('game.highlight.endDate', 'End Date'),
            period: Localize.text('game.highlight.period', 'Period'),
            retailerTypes: Localize.text(
                'game.highlight.retailerTypes',
                'Retailer Types',
            ),
            okModalBody: Localize.text(
                'game.highlight.okModalBody',
                'Are you sure you want to save highlight?',
            ),
            saveButton: Localize.text('game.highlight.saveButton', 'Save'),
        },
        isShowDeleteConfirmation: false,
        defaultFilterItems: {
            status: ['Active', 'Inactive'],
            useDefault: true,
        },
    };

    componentDidMount() {
        this.initGameHighlights();
    }

    initGameHighlights = async () => {
        this.props.setLoading(true);
        this.props.getGameOptions();
        this.props.initCurrentGameHighlight();
        this.props.initGameHighlightsList();
        this.props.setAction(GAME_HIGHLIGHT_LIST);
        await this.props.getGameHighlightList({
            page: this.state.page,
            size: TOTAL_PER_PAGE,
            sortColumn: 'startDate',
            sortOrder: 'DESC',
            filters: [],
        });
        this.props.setLoading(false);
    };
    toggleDeleteConfirmationDialog = () => {
        this.setState((prevState) => ({
            isShowDeleteConfirmation: !prevState.isShowDeleteConfirmation,
        }));
    };
    confirmDelete = async () => {
        const { currentGameHighlight, deleteGameHighlights } = this.props;
        if (currentGameHighlight && currentGameHighlight.id) {
            await deleteGameHighlights(currentGameHighlight.id);
            this.toggleDeleteConfirmationDialog();
            this.initGameHighlights();
        }
    };
    handleFilterApply = (selectedItems, query) => {
        let filters = selectItemsToFilter(selectedItems);
        this.setState({ defaultFilterItems: { useDefault: false } });

        this.props.getGameHighlightList({
            page: 0,
            size: TOTAL_PER_PAGE,
            filters,
            query,
        });
    };

    handleClearFilters = async () => {
        this.props.getGameHighlightList({
            page: this.state.page,
            size: TOTAL_PER_PAGE,
            sortColumn: 'startDate',
            sortOrder: 'DESC',
            filters: [],
        });

        this.setState({ defaultFilterItems: { useDefault: false } });
    };

    displayCreateForm = () => {
        this.props.setAction(GAME_HIGHLIGHT_CREATE_VIEW);
        this.props.getGameHighlightColors();
    };

    handleSelectTablePage = ({ size, page, sortOrder, sortColumn, query }) => {
        let filters = selectItemsToFilter(this.props.selectedItems);
        page = page <= 0 ? 0 : page - 1;
        this.setState({ page: page });
        this.props.getGameHighlightList({
            page: page,
            size,
            sortColumn: sortColumn,
            sortOrder: sortOrder,
            filters: filters,
            query,
        });

        this.props.getGameHighlightColors();
    };

    handleSearch = (query) => {
        this.props.getGameHighlightList({
            page: 0,
            size: TOTAL_PER_PAGE,
            sortColumn: 'startDate',
            sortOrder: 'DESC',
            filters: [],
            query,
        });
    };

    showReadForm = (val) => {
        if (userHasPermission([ROLE_RE_GAME_HIGHLIGHT_VIEW])) {
            this.props.getGameHighlightColors();
            this.props.getRetailerTypeOptions();

            const row = this.props.gameHighlightList.content.filter(
                (a) => a.id === val,
            );
            this.props.setAction(GAME_HIGHLIGHT_READ_VIEW);
            if (row.length > 0) {
                this.props.updateCurrentGameHighlight({
                    id: row[0].id,
                    name: row[0].name,
                    colourId: row[0].colour?.id.toString(),
                    period: row[0].period?.toString(),
                    startDate: row[0].startDate,
                    endDate: row[0].endDate,
                    itemId: row[0].itemId,
                    retailerTypes: row[0].retailerTypes,
                    status: row[0].status?.code,
                    colour: row[0].colour,
                    itemDisplayNames: row[0]?.itemDisplayNames,
                });
            }
        }
    };

    editHighlight = (val) => {
        this.props.updateCurrentGameHighlight({
            id: val.id,
            name: val.name,
            colourId: val.colour?.id.toString(),
            period: val.period?.toString(),
            startDate: val.startDate,
            endDate: val.endDate,
            itemId: val.itemId,
            retailerTypes: val.retailerTypes,
            status: val.status,
            colour: val.colour,
        });
        this.props.setAction(GAME_HIGHLIGHT_EDIT_VIEW);
    };

    returnOnSuccess = async () => {
        await this.initGameHighlights();
        this.props.updateSuccess({
            msg: `The highlight was saved successfully.`,
            target: 'GameHighlightsPage',
        });
    };

    render() {
        const {
            gameHighlightList,
            gameHighlightsColours,
            gameList,
            retailerTypeOptions,
            currentGameHighlight,
            action,
            loading,
        } = this.props;
        let actionsMenu = [];

        const formatPeriod = (period) => {
            return period === '1'
                ? period + ' week'
                : period === '-1'
                    ? 'Never'
                    : period + ' weeks';
        };

        const {
            ROLE_RE_GAME_HIGHLIGHT_UPDATE,
            ROLE_RE_GAME_HIGHLIGHT_CREATE,
            ROLE_RE_GAME_HIGHLIGHT_DELETE,
        } = permissions;

        const backToListJSX = (
            <div className="nav-back">
                <span
                    onClick={this.initGameHighlights}
                    className="caption-text clickable">
                    {'<'} back to <b>Game Highlight List</b>
                </span>
            </div>
        );

        if (action === GAME_HIGHLIGHT_EDIT_VIEW) {
            return (
                <div className="data-display-wrapper">
                    {backToListJSX}
                    <CreateGameHighlights
                        returnToList={this.initGameHighlights}
                        returnOnSuccess={this.returnOnSuccess}
                        gameList={gameList}
                        highlightsColours={gameHighlightsColours}
                        currentGameHighlight={currentGameHighlight}
                        localizeDetail={this.state.GameHighlights}
                    />
                </div>
            );
        }

        if (action === GAME_HIGHLIGHT_CREATE_VIEW) {
            return (
                <div className="data-display-wrapper">
                    {backToListJSX}
                    <CreateGameHighlights
                        returnToList={this.initGameHighlights}
                        returnOnSuccess={this.returnOnSuccess}
                        gameList={gameList}
                        highlightsColours={gameHighlightsColours}
                        localizeDetail={this.state.GameHighlights}
                    />
                </div>
            );
        }

        if (action === GAME_HIGHLIGHT_READ_VIEW) {
            const selectedRetailerOptions =
                currentGameHighlight &&
                    currentGameHighlight?.retailerTypes?.length
                    ? filter(retailerTypeOptions, (rto) =>
                        includes(
                            currentGameHighlight?.retailerTypes,
                            rto.value,
                        ),
                    )
                    : [];
            let selectedGames = [];

            currentGameHighlight?.itemId?.forEach((val) => {
                const list = gameList.filter(
                    (game) => game.id.toString() === val,
                );
                if (list.length > 0) {
                    const gameValue = list[0];
                    selectedGames.push({
                        id: gameValue.id,
                        name: gameValue.name,
                        label: gameValue.name,
                    });
                }
            });
            const today = formatToServerDate(new Date());
            const activeGameHighlight =
                (currentGameHighlight.period != null &&
                    currentGameHighlight.period != -1) ||
                (currentGameHighlight.startDate &&
                    currentGameHighlight.endDate &&
                    currentGameHighlight.startDate <= today &&
                    currentGameHighlight.endDate >= today);

            return (
                <div className="data-display-wrapper">
                    {backToListJSX}
                    <SfaForm
                        name="GameHighlightsForm"
                        headerText={this.state.GameHighlights.gameHighlight}
                        showSaveCancel={false}
                        showEdit={true}
                        editButtonRoles={[ROLE_RE_GAME_HIGHLIGHT_UPDATE]}
                        cancelButtonRoles={[ROLE_RE_GAME_HIGHLIGHT_UPDATE]}
                        deleteButtonRoles={[ROLE_RE_GAME_HIGHLIGHT_DELETE]}
                        showCancel={true}
                        cancelButtonText={Localize.text(
                            'cancel.text',
                            'Cancel',
                        )}
                        cancelButtonClass="transparent-btn"
                        onCancel={this.initGameHighlights}
                        onEdit={() => this.editHighlight(currentGameHighlight)}
                        showDelete={true}
                        deleteButtonText={Localize.text(
                            'delete.text',
                            'Delete',
                        )}
                        deleteButtonClass="secondary"
                        floated={'left'}
                        onDelete={this.toggleDeleteConfirmationDialog}
                        disableDelete={activeGameHighlight}
                        deleteButtonPopup={
                            activeGameHighlight
                                ? {
                                    content:
                                        'This highlight is currently active and cannot be deleted.',
                                    position: 'top left',
                                    style: { animation: 'none', transition: 'none' }
                                }
                                : null
                        }
                        loading={loading}>
                        <OkCancelModal
                            header={Localize.text(
                                'game.highlight.warning.header',
                                'Warning',
                            )}
                            body={Localize.text(
                                'game.highlight.warning.body',
                                'Are you sure you want to delete this Game Highlight?',
                            )}
                            cancelFunction={this.toggleDeleteConfirmationDialog}
                            okFunction={this.confirmDelete}
                            isOpen={this.state.isShowDeleteConfirmation}
                            okText={Localize.text('delete.text', 'Delete')}
                            cancelText={Localize.text('cancel.text', 'Cancel')}
                            okButtonClass="primary"
                        />
                        <SfaReadView
                            elements={[
                                {
                                    label: `${this.state.GameHighlights.highlightId}`,
                                    value: currentGameHighlight?.id,
                                },
                                {
                                    label: `${this.state.GameHighlights.highlightName}`,
                                    value: currentGameHighlight?.name,
                                },
                                {
                                    label: `${this.state.GameHighlights.highlightColour}`,
                                    value: (
                                        <ColourComponent
                                            colourCode={
                                                currentGameHighlight?.colour
                                                    ?.colourCode
                                            }
                                            colourName={
                                                currentGameHighlight?.colour
                                                    ?.colourName
                                            }
                                        />
                                    ),
                                },
                                {
                                    label: `${this.state.GameHighlights.newGame}`,
                                    value: currentGameHighlight?.period
                                        ? 'Yes'
                                        : 'No',
                                },
                                {
                                    label: `${this.state.GameHighlights.startDate}`,
                                    value: formatToDisplayDate(
                                        currentGameHighlight?.startDate,
                                    ),
                                },
                                {
                                    label: `${this.state.GameHighlights.endDate}`,
                                    value: formatToDisplayDate(
                                        currentGameHighlight?.endDate,
                                    ),
                                },
                                {
                                    label: `${this.state.GameHighlights.period}`,
                                    value:
                                        currentGameHighlight?.period ===
                                            undefined
                                            ? ''
                                            : formatPeriod(
                                                currentGameHighlight?.period.toString(),
                                            ),
                                },
                            ]}
                        />
                        <PillList
                            label={this.state.GameHighlights.games}
                            list={selectedGames}
                            displayAttr="label"
                        />
                        <PillList
                            label={this.state.GameHighlights.retailerTypes}
                            list={selectedRetailerOptions}
                            displayAttr="label"
                        />
                    </SfaForm>
                </div>
            );
        }

        return (
            <Page
                title={this.state.GameHighlights.addEditGameHighlights}
                onAddButtonClick={this.displayCreateForm}
                addButtonRoles={[ROLE_RE_GAME_HIGHLIGHT_CREATE]}
                loading={loading}>
                <div>
                    <FilterSection
                        filters={[
                            {
                                label: `${this.state.GameHighlights.highlightStatus}`,
                                name: 'status',
                                multiple: true,
                                toggleAll: true,
                                client: true,
                                searchable: true,
                                items: [
                                    { text: 'ACTIVE', value: 'Active' },
                                    { text: 'INACTIVE', value: 'Inactive' },
                                ],
                                defaultSelected: this.state.defaultFilterItems
                                    .useDefault
                                    ? this.state.defaultFilterItems.status
                                    : '',
                            },
                        ]}
                        onApplyFilter={this.handleFilterApply}
                        onClearFilters={this.handleClearFilters}
                    />
                    <div className="data-display-content">
                        <Table
                            actionsMenu={actionsMenu}
                            pagination
                            content={gameHighlightList?.content}
                            contentKey="id"
                            totalPages={gameHighlightList.totalPages}
                            totalElements={gameHighlightList.totalElements}
                            size={gameHighlightList.size}
                            page={gameHighlightList.number}
                            loading={loading}
                            selector={{
                                type: 'callbackWithId',
                                callback: (id) => this.showReadForm(id),
                            }}
                            columns={[
                                {
                                    name: 'id',
                                    title: `${this.state.GameHighlights.highlightId}`,
                                    sortable: true,
                                    searchable: true,
                                },
                                {
                                    name: 'name',
                                    title: `${this.state.GameHighlights.highlightName}`,
                                    sortable: true,
                                    searchable: true,
                                },
                                {
                                    name: 'colour',
                                    title: `${this.state.GameHighlights.colour}`,
                                    markup: (value) => {
                                        return (
                                            <div
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '100%',
                                                    backgroundColor:
                                                        value.colourCode,
                                                }}></div>
                                        );
                                    },
                                },
                                {
                                    name: 'itemId',
                                    title: `${this.state.GameHighlights.games}`,
                                    formatter: (val, data) => {
                                        if (data?.period === undefined) {
                                            return 'Multiple';
                                        } else {
                                            return 'All New Games';
                                        }
                                    },
                                },
                                {
                                    name: `startDate`,
                                    title: `${this.state.GameHighlights.time}`,
                                    sortable: true,
                                    formatter: (val, rowData) => {
                                        if (rowData?.period) {
                                            return formatPeriod(
                                                rowData.period.toString(),
                                            );
                                        }
                                        return (
                                            rowData.startDate +
                                            ' to ' +
                                            rowData.endDate
                                        );
                                    },
                                },
                                {
                                    name: 'status',
                                    title: `${this.state.GameHighlights.highlightStatus}`,
                                },
                            ]}
                            fetchData={this.handleSelectTablePage}
                            onSearch={this.handleSearch}
                            noDataMessage="There are no game highlights"
                        />
                    </div>
                </div>
            </Page>
        );
    }
}
const mapStateToProps = ({
    gameHighlightsOptions,
    tableFilter,
    retailerTypeOptions,
    currentGameHighlight,
}) => {
    return {
        ...gameHighlightsOptions,
        ...tableFilter,
        retailerTypeOptions: retailerTypeOptions.options,
        currentGameHighlight,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getGameHighlightList: (args) => dispatch(getGameHighlightList(args)),
        getGameHighlightColors: () => dispatch(getGameHighlightColors()),
        getRetailerTypeOptions: () => dispatch(getRetailerTypeOptions()),
        updateSuccess: ({ msg, target }) => dispatch(success({ msg, target })),
        initCurrentGameHighlight: () => dispatch(initCurrentGameHighlight()),
        initGameHighlightsList: () => dispatch(initGameHighlightsList()),
        getGameOptions: () => dispatch(getGameOptions()),
        updateCurrentGameHighlight: (state) =>
            dispatch(updateCurrentGameHighlight(state)),
        setAction: (action) => dispatch(setAction(action)),
        setLoading: (loading) => dispatch(setLoading(loading)),
        gameHighlightsError: (msg, target) =>
            dispatch(GameHighlightsError(msg, target)),
        deleteGameHighlights: (id) => dispatch(deleteGameHighlight(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GameHighlightsPage);
